import React, { Suspense } from "react";
import "./App.scss";
import { HashRouter, Routes, Route, Outlet } from "react-router-dom";

import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Sidebar from "./Components/Sidebar";
import ScrollTop from "./Components/ScrollTop";

import HeaderTwo from "./Components/HeaderTwo";

import { defaultRoutes, petitionRoutes } from "./routes";

function App() {
  return (
    <HashRouter>
      <ScrollTop />
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route element={<><Header /><main><Outlet /></main><Footer /><Sidebar /></>}>
            {defaultRoutes.map((route, index) => {
              return (
                <Route key={index} path={route.path} name={route.name} element={<route.element />} />
              )
            })}
          </Route>
          <Route element={<><HeaderTwo /><main><Outlet /></main><Footer /></>}>
            {petitionRoutes.map((route, index) => {
              return (
                <Route key={index} path={route.path} name={route.name} element={<route.element />} />
              )
            })}
          </Route>
        </Routes>
      </Suspense>
    </HashRouter>
  );
}

export default App;
